import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

import Pricing from './Pricing';
import { PaymentCompletedPage } from '@/Payment/PaymentCompletedPage';
import Order from '@/Payment/Order'
import OneBtnDialog from '@/Common/OneBtnDialog/OneBtnDialog';
import { connect } from 'react-redux'

import { FetchPaymetMode } from '@/Interface'

class Payment extends Component {
  state = {
    isUploadCompleted: true,
    isPaymentSuccess: false,
    isDialogOpened: false,
    dialogType: "errorPerPayment"
  };

  refreshUserData = () => {
    this.componentDidMount()
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    FetchPaymetMode()
    // WatermarkPayment일 때
    const { state } = this.props.history.location
    if (state && state.videoId) {
      this.isInitialized = true
    }
  }

  isInitialized = false
  componentWillReceiveProps(nextProps) {
    if (!this.isInitialized) this.isInitialized = true
    else if (this.isInitialized && this.props.value !== nextProps.value && window.location.pathname.toLowerCase() === '/payment/orderreview') {
      this.props.history.replace('/payment')
    }
  }

  orderReviewFinished = info => {
    const { history } = this.props;
    const { result, type } = info;
    if (type === 'PerPayment' && result === 'Success') {
      this.setState({ isPaymentSuccess: true }, () => {
        history.push({
          pathname: `/payment/completed`,
          state: { info }
        });
      });
      return;
    }

    if (type === 'PerPayment' && (result === 'Failed' || result === 'Error')) {
      //console.log('편당 결제 실패');
      this.setState({
        isDialogOpened: true,
        dialogType: "errorPerPayment"
      })
      return;
    }

    if (type === 'SubscriptionPayment' && result === 'Success') {
      this.setState({ isPaymentSuccess: true }, () => {
        history.push({
          pathname: `/payment/completed`,
          state: { info }
        });
      });
      return;
    }

    if (type === 'TermPayment' && result === 'Success') {
      this.setState({ isPaymentSuccess: true }, () => {
        history.push({
          pathname: `/payment/completed`,
          state: { info }
        });
      });
      return;
    }

    if (
      type === 'TermPayment' &&
      (result === 'Failed' || result === 'Error')
    ) {
      this.setState({
        isDialogOpened: true,
        dialogType: "errorTermPayment"
      })
      //console.log('정기 결제 실패');
      return;
    }

    if (
      type === 'SubscriptionPayment' &&
      (result === 'Failed' || result === 'Error')
    ) {
      this.setState({
        isDialogOpened: true,
        dialogType: "errorSubscriptionPayment"
      })
      //console.log('정기 결제 실패');
      return;
    }
    if (type === "IssueCoupon" && result === "Success") {

      this.setState({ isPaymentSuccess: true }, () => { 
        history.push({
          pathname: `/payment/completed`,
          state: { info }
        });
      })
      return;
    }
    // ClientPaymentFailed들도 처리 해야되나? 원래라면 해야하긴 함. 일단은 무시
    if (type === 'ClientPaymentFailed') {
      return;
    }
    this.setState({
      isDialogOpened: true,
      dialogType: "errorClientPayment"
    })
    //console.log('결제 실패');
  };

  dialogHandleClose = () => {
    this.setState({
      isDialogOpened: false
    })
  }
  render() {
    const {
      isPaymentSuccess
    } = this.state;
    const { match } = this.props;

    return (
      <div>
        <Route
          exact
          path={match.url}
          component={props => (
            <div className="payment_banner">
              <Pricing
                value={this.props.value}
                {...this.props}
              />
            </div>
          )}
        />

        <Route
          path={`${match.url}/orderReview`}
          component={props => <Order
            {...this.props}
            {...props}
            orderReviewFinished={this.orderReviewFinished}
            refreshUserData={this.refreshUserData}
          />}
        />

        <Route
          path={`${match.url}/completed`}
          component={props =>
              <PaymentCompletedPage {...props} />
          }
        />

        <OneBtnDialog
          open={this.state.isDialogOpened}
          closeBtn={this.dialogHandleClose}
          onButtonClick={this.dialogHandleClose}
          dialogType={this.state.dialogType}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
  value: state.langStore.lang
})

export default connect(
  mapStateToProps,
  null
)(Payment)